<template>
  <v-dialog width="400" opacity="0" persistent v-bind="{ ...$props, ...$attrs }">
    <v-card max-width="400" class="pa-8 low-data-card">
      <div class="warning-icon-container">
        <DpplSvg file-name="warning-circle-icon" />
      </div>
      <h3 class="new-h3 low-data-title">
        Understanding Data Limitations
      </h3>
      <p class="new-body-text low-data-content">
        Due to a low percentage of submitted data, we recommend
        <b>being cautious</b> when drawing conclusions from this report.
      </p>
      <p class="new-body-text low-data-content">
        For an alternate view of the gender distribution of your candidate pool,
        check out our
        <b>
          Gender Report.
        </b>
      </p>
      <p class="new-body-text low-data-content">
        To better understand how your survey collection can be improved,
        check out the
        <b>
          Distribution Insights
        </b>
        tab in this report.
      </p>
      <div class="w-100 d-flex align-center justify-center mb-2">
        <DpplNewButton
          color="brandPrimary"
          width="100%"
          @click="handleViewDistributionInsights"
        >
          View Distribution Insights Tab
        </DpplNewButton>
      </div>
      <div class="w-100 d-flex align-center justify-center">
        <DpplNewButton
          width="calc(50% - 4px)"
          class="mr-2"
          variant="outlined"
          color="brandPrimary"
          @click="handleViewDataAnywayClick"
        >
          View survey data
        </DpplNewButton>
        <DpplNewButton
          width="calc(50% - 4px)"
          variant="outlined"
          color="brandPrimary"
          :to="genderReportRoute"
          @click="trackGenderReportClick"
        >
          Go to the Gender Report
        </DpplNewButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useTracking } from '@/stores/tracking/tracking';

const emit = defineEmits(['update:viewDataAnyway', 'update:isSurveyInsightsTab']);

const route = useRoute();

const genderReportRoute = computed(() => {
  const newQuery = { ...(route.query || {}) };

  delete newQuery.tab;
  delete newQuery.country;

  return {
    name: 'gender-report',
    query: newQuery,
  };
});

const handleViewDistributionInsights = () => {
  useTracking().dsrClickedViewData({ tab: 'Distribution Insights', modal: 'Low Data' });

  emit('update:isSurveyInsightsTab', false);
};

const handleViewDataAnywayClick = () => {
  useTracking().dsrClickedViewData({ tab: 'Survey Insights', modal: 'Low Data' });

  emit('update:viewDataAnyway', true);
};

const trackGenderReportClick = () => {
  useTracking().dsrClickedViewGenderReport({ modal: 'Low Data' });
};
</script>

<style lang="less" scoped>
.low-data-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px !important;
}

.warning-icon-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: fade(@basic-yellow, 10%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.low-data-title {
  text-align: center;
  color: @text-darkest;
  margin-bottom: 16px;
}

.low-data-content {
  color: @text-light;
  margin-bottom: 16px !important;
  text-align: center;
}
</style>
